import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { User, TtIntake } from "@/CodegenTypes";

import { sumBy, first, sortBy } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import { customMoment } from "@/main";
import { useQuery } from "@vue/apollo-composable";
import { computed, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { useRootStore } from "@/store/pinia";
import TTIntakeDetailsModal from "@/components/modules/bet-details/TTIntakeDetailsModal.vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTIntakeDetails',
  setup(__props) {

const route = useRoute();
const store = useRootStore();
const { $t } = useTranslation();

const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
});

const { result, loading } = useQuery<{ user: User }>(queries.userTtIntakes, {
  releaseDate: computed(() =>
    customMoment(selectedStartReleaseDate.value).startOf("day").toDate()
  ),
  userId: computed(() => store.account?.userId),
});

const selectedIntakeData = ref<null | TtIntake[]>(null);
const showIntakeDetailModal = ref(false);

const intakeReportData = computed(() => {
  if (!result.value?.user) {
    return [];
  }
  const users = result.value?.user.ttIntakes.map((i) => {
    const amount = sumBy(i.rows, (r) => r.unit);
    return {
      ...i,
      amount,
    };
  });

  const sortedData = sortBy(users, (d) => d.intakerUserId);
  return sortedData;
});

const intakeReportDataSummary = computed(() => {
  return {
    amount: formatDollar(sumBy(intakeReportData.value, (d) => d.amount)),
  };
});

function openIntakeDetail(userId: string) {
  const selectedUser = result.value?.user?.ttIntakes.find(
    (u) => u.intakerUserId === userId
  );
  selectedIntakeData.value = selectedUser?.rows || [];
  showIntakeDetailModal.value = true;
}

return { __sfc: true,route, store, $t, selectedStartReleaseDate, result, loading, selectedIntakeData, showIntakeDetailModal, intakeReportData, intakeReportDataSummary, openIntakeDetail, formatDollar, TTIntakeDetailsModal }
}

})